// `video.motion`: live's Motion Control tool (#214).
// Live's label map (`MOTION_CONTROL`); the tool's own form builds the body.
import { VideoMotionQuote, VideoMotionRequest } from "../../../api/generated/zod";
import type { JobTypeModule } from "./contract";

export const jobType: JobTypeModule<"video.motion"> = {
  type: "video.motion",
  label: "Motion Control",
  source: "form",
  pair: "video.motion",
  fields: () => ({}),
  request: VideoMotionRequest,
  quote: VideoMotionQuote,
};
